import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';

const initialState = {
  loading: false,
  invoicesList: []
};
const invoices = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        invoicesList: action.payload?.data?.result,
        count: action.payload?.data?.count
      };
    },
    getById(state, action) {
      return {
        ...state,
        invoiceInfo: action.payload?.data
      };
    }
  }
});

export const invoicesActions = invoices.actions;

export const getInvoicesAction = (data) => async (dispatch) => {
  dispatch(invoicesActions.setLoading(true));
  try {
    const res = await api.post(`api/invoice`, data);
    if (res.status === 200 && res?.data) {
      dispatch(invoicesActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(invoicesActions.setLoading(false));
  }
};

export const getInvoicesActionsById = (id) => async (dispatch) => {
  dispatch(invoicesActions.setLoading(true));
  try {
    const res = await api.get(`api/invoice/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(invoicesActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(invoicesActions.setLoading(false));
  }
};

export const clearInvoicesById = () => async (dispatch) => {
  dispatch(invoicesActions.getById(''));
};

export default invoices.reducer;
